/**
 * 其知网 出售管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>出售管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.title" style="width:120px" placeholder="输入专利名称" clearable></el-input>
        <el-input size="small" v-model="formInline.zlid" style="width:120px" placeholder="输入专利号" clearable></el-input>
        类型：
        <el-select size="small" v-model="formInline.type" style="width:100px" placeholder="请选择" clearable>
          <el-option v-for="type in patentType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        状态：
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择" clearable>
          <el-option v-for="type in patentStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        授权状态：
        <el-select size="small" v-model="formInline.auth" style="width:100px" placeholder="请选择" clearable>
          <el-option v-for="type in patentAuth" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        出售方式：
        <el-select size="small" v-model="formInline.sale_type" style="width:100px" placeholder="请选择" clearable>
          <el-option v-for="type in saleType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-document-add" title="添加单条出售专利" @click="handleAdd">添加</el-button>

        <el-button size="small" type="primary" icon="" title="批量导入出售专利" @click="handleExport">批量导入</el-button>   

        <!-- 上传组件 -->
        <!-- <Upload v-bind:isDialogMode="false" v-bind:uploadUrl="uploadUrl" @callFather="callFather"></Upload> -->

        <el-button size="small" type="warning" icon="" title="下载导入模板" @click="downloadExcel">下载模板</el-button>
        <el-button size="small" type="warning" icon="" title="批量审核勾选专利" @click="verifyCheckSale">审核</el-button>
        <el-button size="small" type="warning" icon="" title="批量设置勾选专利行业" @click="cateCheckSale">行业设置</el-button>
        <el-button size="small" type="danger" icon="" title="批量删除勾选中的数据" @click="delCheckSale">删除</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="application_number" align="center" label="专利号" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="price" align="center" label="出售价格" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="category_name" align="center" label="所属行业" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="专利状态" width="70" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sale_type" align="center" label="出售方式" width="70" :formatter="saleFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="auth_status" align="center" label="授权状态" width="70" :formatter="authFormat" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="add_time" align="center" label="发布时间" width="150" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="upd_time" align="center" label="更新时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="takedown_date" align="center" label="截止时日期" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="handleverify(scope.$index, scope.row)">审核</el-button>
          <el-button size="mini" type="success" @click="handleCate(scope.$index, scope.row)" title="设置行业">行业</el-button>
          <el-button size="mini" type="danger" @click="delSale(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="50%" @click="closeDialog('addForm')">
      <el-form label-width="120px" :model="addForm" ref="addForm" :rules="addFormRules">
        <el-row>
            <el-form-item label="专利名称" prop="title">
              <el-input size="small" v-model="addForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="专利号" prop="application_number">
              <el-input size="small" v-model="addForm.application_number" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select size="small" v-model="addForm.type" style="width:140px" placeholder="请选择">
                <el-option v-for="type in patentTypes" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属行业(单选)" prop="category_id">
              <el-select size="small" v-model="addForm.category_id" style="width:140px" placeholder="请选择" @change="changeCate">
                <el-option v-for="type in cateList" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属行业(多选)">
              <el-checkbox-group style="display: inline-block" v-model="checkedDirectionsEquipments">
                <el-checkbox
                v-for="data in cateList" 
                :label="data.key"
                :key="data.value"
                :checked="data.checked">
                </el-checkbox>
              </el-checkbox-group>
        </el-form-item>

            <!-- <div>若需议价可不填写出售金额</div> -->
            <el-form-item label="出售价格" prop="price">
              <el-input size="small" v-model="addForm.price" auto-complete="off" type="number" style="width: 140px;"></el-input>
              <span style="color: #606266;font-size: 12px;">若需议价可不填写出售金额</span>
            </el-form-item>

            <el-form-item label="是否议价" prop="is_negotiate">
              <el-radio-group type="status" v-model="addForm.is_negotiate"> 
                    <el-radio v-model="addForm.is_negotiate" :label="1" style="font-size: 25px">是</el-radio>
                    <el-radio v-model="addForm.is_negotiate" :label="2">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="出售方式" prop="sale_type">
              <el-radio-group type="status" v-model="addForm.sale_type"> 
                    <el-radio v-model="addForm.sale_type" :label="1" style="font-size: 25px">许可</el-radio>
                    <el-radio v-model="addForm.sale_type" :label="2">转让</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="授权状态" prop="auth_status">
              <el-radio-group type="status" v-model="addForm.auth_status"> 
                    <el-radio v-model="addForm.auth_status" :label="1" style="font-size: 25px">已下证</el-radio>
                    <el-radio v-model="addForm.auth_status" :label="2">未下证</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="是否通过" prop="status">
              <!-- <el-select size="small" v-model="infoForm.type" style="width:140px" placeholder="请选择">
                <el-option v-for="type in cateType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select> -->
                 <el-radio-group type="status" v-model="addForm.status"> 
                    <el-radio v-model="addForm.status" :label="1" style="font-size: 25px">通过</el-radio>
                    <el-radio v-model="addForm.status" :label="2">不通过</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" auto-complete="off" placeholder="值越小越靠前"></el-input>
            </el-form-item> -->

             <el-form-item label="截止时间" prop="takedown_time">
              <el-input size="small" v-model="addForm.takedown_date" auto-complete="off" placeholder="例:2022-07-27"></el-input>
            </el-form-item>

            <el-form-item label="备注" prop="note">
              <el-input size="small" v-model="addForm.note" auto-complete="off" placeholder="若审核不通过请填写原因"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button size="mini" type="primary" @click="submitAddForm('addForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("addForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-row>
            <el-form-item label="专利名称" prop="title">
              <el-input size="small" v-model="infoForm.title" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号" prop="application_number">
              <el-input size="small" v-model="infoForm.application_number" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <!-- <el-select size="small" v-model="infoForm.type" style="width:140px" placeholder="请选择">
                <el-option v-for="type in patentTypes" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select> -->
              <el-input size="small" v-model="infoForm.type" auto-complete="off" disabled></el-input>
            </el-form-item>

            <el-form-item label="状态" prop="status">
              <!-- <el-select size="small" v-model="infoForm.type" style="width:140px" placeholder="请选择">
                <el-option v-for="type in cateType" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select> -->
                 <el-radio-group type="status" v-model="infoForm.status"> 
                    <el-radio v-model="infoForm.status" :label="1" style="font-size: 25px">正常</el-radio>
                    <el-radio v-model="infoForm.status" :label="2">异常</el-radio>
                    <el-radio v-model="infoForm.status" :label="3">已下架</el-radio>
                    <el-radio v-model="infoForm.status" :label="4">待审核</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="infoForm.sort" auto-complete="off" placeholder="值越小越靠前"></el-input>
            </el-form-item> -->
            <el-form-item label="截止时间" prop="takedown_time">
              <el-input size="small" v-model="infoForm.takedown_date" auto-complete="off" placeholder="例:2022-07-27"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitForm('infoForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 审核界面 -->
    <el-dialog :title="title" :visible.sync="verifyFormVisible" width="50%" @click="closeDialog('verifyForm')">
        <el-form label-width="120px" :model="verifyForm" ref="verifyForm" :rules="verifyFormRules">
          <el-row>
              <el-form-item label="专利名称" prop="title">
                <el-input size="small" v-model="verifyForm.title" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="专利号" prop="application_number">
                <el-input size="small" v-model="verifyForm.application_number" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="类型" prop="type">
                <el-input size="small" v-model="verifyForm.type" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="是否通过" prop="status">
                  <el-radio-group type="status" v-model="verifyForm.status"> 
                      <el-radio v-model="verifyForm.status" :label="1" style="font-size: 25px">通过</el-radio>
                      <el-radio v-model="verifyForm.status" :label="2">不通过</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="note">
                <el-input size="small" v-model="verifyForm.note" auto-complete="off" placeholder="若审核不通过请填写原因"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="submitVerifyForm('verifyForm')">保存</el-button>
                <el-button size="mini" @click='closeDialog("verifyForm")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 选中审核页面 -->
    <el-dialog :title="title" :visible.sync="verifyCheckVisible" width="50%" @click="closeDialog('verifyCheck')">
        <el-form label-width="120px" :model="verifyCheck" ref="verifyCheck" :rules="verifyCheckRules">
          <el-row>
              <el-form-item label="是否通过" prop="status">
                  <el-radio-group type="status" v-model="verifyCheck.status"> 
                      <el-radio v-model="verifyCheck.status" :label="1" style="font-size: 25px">通过</el-radio>
                      <el-radio v-model="verifyCheck.status" :label="2">不通过</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="备注" prop="note">
                <el-input size="small" v-model="verifyCheck.note" auto-complete="off" placeholder="若审核不通过请填写原因"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="submitVerifyCheck('verifyCheck')">保存</el-button>
                <el-button size="mini" @click='closeDialog("verifyCheck")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 行业设置 -->
    <el-dialog :title="title" :visible.sync="cateFormVisible" width="50%" @click="closeDialog('cateForm')">
        <el-form label-width="120px" :model="cateForm" ref="cateForm" :rules="cateFormRules">
          <el-row>
             <el-form-item label="专利名称" prop="title">
                <el-input size="small" v-model="cateForm.title" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="专利号" prop="application_number">
                <el-input size="small" v-model="cateForm.application_number" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item label="所属行业(单选)" prop="category_id">
                <!-- <el-input size="small" v-model="cateForm.category_id" auto-complete="off"></el-input> -->
                <el-select size="small" v-model="cateForm.category_id" style="width:140px" placeholder="请选择" @change="changeCates">
                  <el-option v-for="type in cateList" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属行业(多选)">
              <el-checkbox-group style="display: inline-block" v-model="checkedDirectionsEquipments">
                <el-checkbox
                v-for="data in cateList" 
                :label="data.key"
                :key="data.value"
                :checked="data.checked">
                </el-checkbox>
              </el-checkbox-group>
              </el-form-item>

              <el-form-item>
                <el-button size="mini" type="primary" @click="submitCateForm('cateForm')">保存</el-button>
                <el-button size="mini" @click='closeDialog("cateForm")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 选中行业设置页面 -->
    <el-dialog :title="title" :visible.sync="cateCheckVisible" width="50%" @click="closeDialog('cateCheck')">
        <el-form label-width="120px" :model="cateCheck" ref="cateCheck" :rules="cateCheckRules">
          <el-row>
              <el-form-item label="所属行业" prop="category_id">
                <!-- <el-input size="small" v-model="cateForm.category_id" auto-complete="off"></el-input> -->
                <el-select size="small" v-model="cateCheck.category_id" style="width:140px" placeholder="请选择" @change="changeCateCheck">
                  <el-option v-for="type in cateList" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="submitCateCheck('cateCheck')">保存</el-button>
                <el-button size="mini" @click='closeDialog("cateCheck")'>取消</el-button>
              </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M</div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { webCategoryList, webMarketEditSale, webUrl, webMarketDelSale, webMarketDelCheckSale, webMarketSaleList,
    webMarketSaleCateList, webMarketVerifySale, webMarketVerifyCheckSale, webMarketSetCateSale, webMarketSetCateCheckSale,
    webMarketAddSale, webUploadMarketSaleExcel } from '../../api/webMG'
import Pagination from '../../components/Pagination'
// import Upload from '../../components/upload.vue'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

import { checkLogin } from '../../utils/util'
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {

      // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, // 控制编辑页面显示与隐藏
      verifyFormVisible: false,// 控制审核页面显示与隐藏
      addFormVisible: false,// 控制添加页面显示与隐藏
      cateFormVisible: false,// 控制行业选择页面显示与隐藏
      excelFormVisible: false,// 控制Excel表格上传页面显示与隐藏
      verifyCheckVisible: false,// 控制选中审核页面显示与隐藏
      cateCheckVisible: false,// 控制选中行业设置页面显示与隐藏
      uploadUrl: '',
      title: '添加分类',
      excelUrl: '',
      multipleSelection: [],
      patentTypes: [
        { key: '高价值专利', value: '高价值专利' },
        { key: '实用新型', value: '实用新型' },
        { key: '发明专利', value: '发明专利' },
      ],
      patentType: [
        { key: '全部', value: 0 },
        { key: '高价值专利', value: '高价值专利' },
        { key: '实用新型', value: '实用新型' },
        { key: '发明专利', value: '发明专利' },
      ],
      patentStatus: [
        { key: '全部', value: 0 },
        { key: '正常', value: 1 },
        { key: '异常', value: 2 },
        { key: '已下架', value: 3 },
        { key: '待审核', value: 4 },
      ],
      patentAuth: [
        { key: '全部', value: 0 },
        { key: '已下证', value: 1 },
        { key: '未下证', value: 2 },
      ],
      saleType: [
        { key: '全部', value: 0 },
        { key: '许可', value: 1 },
        { key: '转让', value: 2 },
      ],
      cateList: [],
      infoForm: {
        id: '',
        title: '',
        type: '',
        status: '',
        application_number: '',
        takedown_date: ''
      },
      checkedDirectionsEquipments: [],
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/market/readExcelLarge',
      // 审核数据model
      verifyForm: {
        id: '',
        title: '',
        type: '',
        sort: '',
        status: '',
        note: '',
        application_number: '',
      },
      // 批量审核数据model
      verifyCheck: {
        ids: '',
        status: '',
        note: '',
      },
      // 批量行业设置数据model
      cateCheck: {
        ids: '',
        category_id: '',
        category_name: '',
      },
      // 添加数据model
      addForm: {
        title: '',
        type: '',
        sort: '',
        status: '',
        note: '',
        application_number: '',
        price: '',
        sale_type: '',
        auth_status: '',
        category_id: '',
        category_name: '',
        is_negotiate: '',
        takedown_date: ''
      },
      // 行业分类数据model
      cateForm: {
        id: '',
        title: '',
        application_number: '',
        category_id: '',
        category_name: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        title: '',
        type: '',
        status: '',
        auth: '',
        sale_type: '',
        zlid: ''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      // infoFormRules: {
      //   name: [{required: true, message: '请输入分类名称', trigger: 'blur'}],
      //   type: [{required: true, message: '请选择所属类型', trigger: 'blur'}],
      // },
      // 添加 表单验证
      addFormRules: {
        title: [{required: true, message: '请填写专利名称', trigger: 'blur'}],
        type: [{required: true, message: '请选择专利类型', trigger: 'blur'}],
        application_number: [{required: true, message: '请填写专利号', trigger: 'blur'}],
        sale_type: [{required: true, message: '请选择所出售方式', trigger: 'blur'}],
        auth_status: [{required: true, message: '请选择授权状态', trigger: 'blur'}],
        category_id: [{required: true, message: '请选择所属行业', trigger: 'blur'}],
      },
      // 行业 表单验证
      cateFormRules: {
        category_id: [{required: true, message: '请选择所属行业', trigger: 'blur'}],
      },
      // 审核 表单验证
      verifyFormRules: {
        status: [{required: true, message: '请选择是否通过', trigger: 'blur'}],
      },
      // 选中审核 表单验证
      verifyCheckRules: {
        status: [{required: true, message: '请选择是否通过', trigger: 'blur'}],
      },
      // 选中行业 表单验证
      cateCheckRules: {
        category_id: [{required: true, message: '请选择所属行业', trigger: 'blur'}],
      }
    }
  },
  // 注册组件
  components: {
    Pagination, 
    // Upload
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

      // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/market/readExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webMarketSaleList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleEdit: function(index, row) {
        this.editFormVisible = true
        this.title = '专利修改'
        this.infoForm.id = row.id
        this.infoForm.title = row.title
        this.infoForm.type = row.type
        this.infoForm.status = row.status
        this.infoForm.takedown_date = row.takedown_date
        this.infoForm.application_number = row.application_number
    },
    // 显示审核页
    handleverify: function(index, row) {
      if (row != undefined && row != 'undefined') {
              if(row.status == 3){
                this.$message({
                    type: 'info',
                    message: '该专利已下架,无法进行审核!'
                  })
                  return false
              }
        this.verifyFormVisible = true
        this.title = '专利审核'
        this.verifyForm.id = row.id
        this.verifyForm.title = row.title
        this.verifyForm.type = row.type
        this.verifyForm.sort = row.sort
        this.verifyForm.status = row.status
        this.verifyForm.note = row.note
        this.verifyForm.application_number = row.application_number

      }else{
        this.$message({
              type: 'error',
              message: '未知错误,请联系开发人员'
        })
      }
    },
    // 显示行业选择页
    handleCate: function(index, row) {
        if (row != undefined && row != 'undefined') {
          webMarketSaleCateList()
          .then(res => {
            console.log(res);
            res = checkLogin(res)
            if (res.code == 200) {
              this.cateList = res.data
              this.checkedDirectionsEquipments = row.category_names.split(',')
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.$message.error('登陆已过期,请重新登陆!')
          })
          this.cateFormVisible = true
          this.title = '设置行业'
          this.cateForm.id = row.id
          this.cateForm.title = row.title
          this.cateForm.application_number = row.application_number
          this.cateForm.category_id = row.category_id
          this.cateForm.category_name = row.category_name
      }else{
        this.$message({
              type: 'error',
              message: '未知错误,请联系开发人员'
        })
      }
    },
    // 显示添加页
    handleAdd: function(){
      this.addFormVisible = true
      this.checkedDirectionsEquipments = []
      webMarketSaleCateList()
        .then(res => {
          console.log(res);
            this.title = '添加专利'
            this.addForm.title = ''
            this.addForm.type = ''
            this.addForm.sort = ''
            this.addForm.status = ''
            this.addForm.note = ''
            this.addForm.application_number = ''
            this.addForm.price = ''
            this.addForm.sale_type = ''
            this.addForm.auth_status = ''
            this.addForm.category_id = ''
            this.addForm.category_name = ''
            this.addForm.is_negotiate = ''
          res = checkLogin(res)
          if (res.code == 200) {
            this.cateList = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.icon = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    // 显示Excel导入页面
    handleExport: function(){
      this.title = '批量导入Excel'
      this.excelFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(infoForm) {
      let param = {
        id: this.infoForm.id,
        status: this.infoForm.status,
        takedown_date: this.infoForm.takedown_date
      }
      webMarketEditSale(param)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
    },
    // 提交添加出售专利
    submitAddForm(addForm){
      // console.log(this.checkedDirectionsEquipments)
      this.addForm.directions = this.checkedDirectionsEquipments
      if(this.addForm.directions.length <= 0){
          this.$message({
                  type: 'error',
                  message: '请勾选所属行业'
                })
              return false
      }
      this.$refs[addForm].validate(valid => {
        if (valid) {
          webMarketAddSale(this.addForm)
            .then(res => {
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.addFormVisible = false
              this.loading = false
              this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误！')
              this.addFormVisible = false
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    // 提交审核
    submitVerifyForm(verifyForm) {
      this.$refs[verifyForm].validate(valid => {
        if (valid) {
          webMarketVerifySale(this.verifyForm)
            .then(res => {
              this.verifyFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.verifyFormVisible = false
              this.loading = false
              this.$message.error('系统错误！')
            })
        } else {
          return false
        }
      })
    },
    // 提交行业设置
    submitCateForm(cateForm) {
     this.cateForm.directions = this.checkedDirectionsEquipments
      if(this.cateForm.directions.length <= 0){
          this.$message({
                  type: 'error',
                  message: '请勾选所属行业'
                })
              return false
      }
     this.$refs[cateForm].validate(valid => {
        if (valid) {
          webMarketSetCateSale(this.cateForm)
            .then(res => {
              this.cateFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.cateFormVisible = false
              this.loading = false
              this.$message.error('系统错误！')
            })
        } else {
          return false
        }
      })
    },
    // 提交选中行业设置
    submitCateCheck(cateCheck){

    },
    // 专利状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '正常'
        }else if(row.status == 2){
            return '审核未通过'
        }else if(row.status == 3){
            return '已下架'
        }else if(row.status == 4){
            return '待审核'
        }else{
            return '未知'
        }
    },
    // 出售方式
    saleFormat:function(row,column){
        if(row.sale_type == 1){
            return '许可'
        }else if(row.sale_type == 2){
            return '转让'
        }else{
            return '未知'
        }
    },
    // 授权状态
    authFormat:function(row,column){
        if(row.auth_status == 1){
            return '已下证'
        }else if(row.auth_status == 2){
            return '未下证'
        }else{
            return '未知'
        }
    },
    // 删除专利出售记录
    delSale(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          webMarketDelSale(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('分类删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 删除所有选中的专利出售记录
    delCheckSale(){
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        webMarketDelCheckSale(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 审核选中的专利出售记录 
    verifyCheckSale(){
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        this.title = '批量审核选中专利'
        this.verifyCheckVisible = true
        this.verifyCheck.ids = JSON.stringify(idsArr)
    },
    // 提交 审核选中的专利出售记录
    submitVerifyCheck(verifyCheck){
      this.$refs[verifyCheck].validate(valid => {
        if (valid) {
          webMarketVerifyCheckSale(this.verifyCheck)
            .then(res => {
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.verifyCheckVisible = false
              this.loading = false
              this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误！')
              this.verifyCheckVisible = false
              this.loading = false
            })
        } else {
          return false
        }
      })
    },

    // 设置选中的专利出售记录
    cateCheckSale(){
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        this.title = '批量设置选中专利行业'
        this.cateCheckVisible = true
        this.cateCheck.ids = JSON.stringify(idsArr)
        // 获取行业分类数据
        webMarketSaleCateList()
          .then(res => {
            console.log(res);
            res = checkLogin(res)
            if (res.code == 200) {
              this.cateList = res.data
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.$message.error('登陆已过期,请重新登陆!')
          })
    },
    // 提交 选中行业设置专利
    submitCateCheck(cateCheck){
      this.$refs[cateCheck].validate(valid => {
        if (valid) {
          webMarketSetCateCheckSale(this.cateCheck)
            .then(res => {
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.cateCheckVisible = false
              this.loading = false
              this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误！')
              this.cateCheckVisible = false
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    // 选择行业(添加页面)
    changeCate: function(value){
      const that = this
      that.cateList.forEach(function(item, index){
          if(item.value == value){
            that.addForm.category_name = item.key
          }
      })
    },
    // 选中行业(行业设置页面)
    changeCates: function(value){
      const that = this
      that.cateList.forEach(function(item, index){
          if(item.value == value){
            that.cateForm.category_name = item.key
          }
      })
    },
    // 选中行业(选中行业设置页面)
    changeCateCheck: function(value){
      const that = this
      that.cateList.forEach(function(item, index){
          if(item.value == value){
            that.cateCheck.category_name = item.key
          }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'addForm'){
        this.addFormVisible = false
      }else if(formName == 'verifyForm'){
        this.verifyFormVisible = false
      }else if(formName == 'infoForm'){
        this.editFormVisible = false
      }else if(formName == 'cateForm'){
        this.cateFormVisible = false
      }else if(formName == 'cateCheck'){
        this.cateCheckVisible = false
      }else if(formName == 'verifyCheck'){
        this.verifyCheckVisible = false
      }else{
        return false
      }
      this.$refs[formName].resetFields()
    },
    // 下载出售Excel模板
    downloadExcel(){
       this.$confirm('确定要下载吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          webUploadMarketSaleExcel()
          .then(res => {
                  if (res.code == 200) {
                    this.$message({
                      type: 'success',
                      message: '下载成功'
                    })
                    window.location.href = res.data.value
                    console.log(res.data.value)
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('系统错误!')
                })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          })
        })
      
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Sale.vue